import { useState, useCallback, useEffect } from "react";
import Button from "../../input/button";
import { TextField } from "@mui/material";
import useAdminAPIClient from "../../../api/admin/hooks/useAdminAPIClient";
import { useDispatch } from "react-redux";
import { setAdminConversations } from "../../../redux/actions/admin";

const UserMessaging = ({
  messageRecipient,
  onClearRecipient,
  onMessageSent,
}) => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [saving, setSaving] = useState(false);
  const { sendMessageToUser, getConversations } = useAdminAPIClient();
  const dispatch = useDispatch();

  // Auto-populate userId when messageRecipient is provided
  useEffect(() => {
    if (messageRecipient) {
      setUserId(messageRecipient);
    }
  }, [messageRecipient]);

  const onSubmit = useCallback(async () => {
    setSaving(true);
    const sentToUserId = userId;
    await sendMessageToUser({ userId, message, subject });
    // Refresh conversations to get the new message
    const data = await getConversations();
    if (data?.conversations) {
      dispatch(setAdminConversations(data.conversations));
    }
    setMessage("");
    setSubject("");
    setUserId("");
    if (onClearRecipient) {
      onClearRecipient();
    }
    // Navigate to conversations tab and open this conversation
    if (onMessageSent) {
      onMessageSent(sentToUserId);
    }
    setSaving(false);
  }, [
    userId,
    message,
    subject,
    sendMessageToUser,
    getConversations,
    dispatch,
    onClearRecipient,
    onMessageSent,
  ]);

  return (
    <div className="user-messaging">
      <TextField
        className="messaging_input"
        label="User ID"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />
      <TextField
        className="messaging_input"
        label="Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        className="messaging_input-area scroller"
        placeholder="Message to send to this specific user"
        maxLength={500}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <Button
        text="Send Message"
        disabled={userId.trim().length !== 28 || message.trim().length === 0}
        onClick={onSubmit}
        loading={saving}
      />
    </div>
  );
};

export default UserMessaging;
